import { Flex, Text, type FlexProps } from '@mantine/core';
import { RichTextEditor } from '@shared/ui';
import classes from './FormRichTextEditor.module.scss';
import { memo } from 'react';

interface FormRichTextEditorProps {
  title: string;
  description: string;
  containerProps?: FlexProps;
  placeholder?: string;
  value?: string;
  setValue?: (value: string) => void;
  onChange?: (value: string) => void;
  onBlur?: () => void;
  error?: string;
  [key: string]: any;
}

export const FormRichTextEditor = memo(
  ({
    title,
    description,
    containerProps,
    placeholder,
    value,
    setValue,
    onChange,
    onBlur,
    error,
    ...otherProps
  }: FormRichTextEditorProps) => {
    const handleChange = (newValue: string) => {
      if (setValue) {
        setValue(newValue);
      }
      if (onChange) {
        onChange(newValue);
      }
    };

    return (
      <Flex gap='24' className={classes.formRow} {...containerProps}>
        <Flex direction='column' gap={6} className={classes.leftColumn}>
          <Text className={classes.title}>{title}</Text>
          <Text className={classes.description}>{description}</Text>
          {error && (
            <Text size='sm' c='red'>
              {error}
            </Text>
          )}
        </Flex>

        <RichTextEditor
          className={classes.rightColumn}
          value={value || ''}
          setValue={handleChange}
          placeholder={placeholder}
          {...otherProps}
        />
      </Flex>
    );
  }
);
